module.exports = __webpack_public_path__ + "img/nether_drake_small.a5918ee0.png";